import React from 'react';

import { AutoCompleteInputParams, AutoCompleteValue } from './AutoCompleteTypes';
import { BaseAutoCompleteInput } from './BaseAutoCompleteDropdown.component';

export const SearchDropdown: React.FC<React.PropsWithChildren<AutoCompleteInputParams>> = (
  params,
) => {
  const { clearOnSelect = true } = params;
  const selectedKey = params.selectedKey;
  const [value, setValue] = React.useState<AutoCompleteValue | null>(
    params.autoCompleteValues.find((value) => value.key === selectedKey) || null,
  );

  const prevValueRef = React.useRef<AutoCompleteValue | null>(value);

  React.useEffect(() => {
    updateCurrentValue();
  }, [params.selectedKey]);

  function updateCurrentValue() {
    setValue(params.autoCompleteValues.find((value) => value.key === selectedKey) || null);
  }

  function onInputFocus() {
    if (clearOnSelect) {
      setValue(null);
    }
    prevValueRef.current = value;
  }

  function onInputBlur(curValue: string) {
    const exists = params.autoCompleteValues.some(
      (entity) => curValue && entity.value.name === curValue,
    );
    if (!exists) {
      if (params.allowCreateNew && curValue.length !== 0) {
        params.onSelect({ key: curValue, value: { name: curValue } });
      } else {
        setValue(structuredClone(prevValueRef.current));
      }
    }
  }

  function onSelectValue(updateValue: AutoCompleteValue | null) {
    const exists = params.autoCompleteValues.some(
      (entity) => updateValue?.value.name && entity.value.name === updateValue?.value.name,
    );

    if (!exists) {
      return;
    }
    prevValueRef.current = updateValue;
    params.onSelect(updateValue);
    updateCurrentValue();
  }

  return (
    <BaseAutoCompleteInput
      {...params}
      onSelect={onSelectValue}
      onInputBlur={onInputBlur}
      onInputFocus={onInputFocus}
      value={value}
    />
  );
};
